import _ from 'lodash';
import React, {Component} from 'react';

import dumbBem from 'dumb-bem';
import tx from 'transform-props-with';

import {Title} from 'components/landing/components';
import {Feature} from '../feature';
import {Price} from '../price';

import starIcon from 'images/pricing/star.svg';

import './Plan.css';


let dumbPlan = dumbBem('l-pricing-plan');
let PlanWrp = tx(dumbPlan)('div');

let HoverHeader = tx([{element: 'hover'}, dumbPlan])('div');
let Content = tx([{element: 'content'}, dumbPlan])('div');
let Stars = tx([{element: 'stars'}, dumbPlan])('div');
let Star = tx([{element: 'star'}, dumbPlan])('img');
let Features = tx([{element: 'features'}, dumbPlan])('div');


export class Plan extends Component {
  render() {
    return (
      <PlanWrp modifier={this.props.hover ? 'hover' : ''}>
        <Content>
          {this.props.hover ? <HoverHeader>{this.props.hover}</HoverHeader> : null}
          <Stars>
            {
              _.range(this.props.stars).map((id) => <Star src={starIcon} alt='' key={id} />)
            }
          </Stars>
          <Title modifier='2 name'>{this.props.name}</Title>
          <Title modifier='description'>{this.props.description}</Title>
          <Price heading={this.props.priceHeading} price={this.props.price} period={this.props.period}/>
          <Title modifier='features-description'>{this.props.featuresDescription}</Title>
          <Features>
            {
              this.props.features.map((feature, id) => <Feature
                key={id}
                isMobile={this.props.isMobile}
                {...feature}
              />)
            }
          </Features>
        </Content>
      </PlanWrp>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/landing/pages/pricing/plan/Plan.js